import { Navigate, useLocation } from "react-router-dom";
import { isAdmin } from "@prism/shared/constants";
import { useAuth } from "../context/AuthContext.jsx";

/**
 * Admin-only route guard. Redirects to /login if unauthenticated,
 * or to / (HomeRedirect, which sends each role to its own landing page)
 * if authenticated but not an ADMIN.
 *
 * Use for pages that only BMG staff should see, e.g. /admin/clients.
 * Non-admin users never see a 403 page — they're just quietly redirected
 * to their dashboard. This avoids leaking the existence of admin tools.
 *
 * `allow` admits extra roles (4c: ACCOUNTANT on /agency/contracts, read-only).
 */
export function AdminRoute({ children, requireSuper = false, allow = [] }) {
  const { authenticated, user } = useAuth();
  const location = useLocation();

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!isAdmin(user?.role) && !allow.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }
  // SUPER_ADMIN-only pages (e.g. Team). Legacy ADMINs fall back to the client list.
  if (requireSuper && user?.role !== "SUPER_ADMIN") {
    return <Navigate to="/admin/clients" replace />;
  }
  return children;
}
